import { PhoneticMode, DigitFormat } from '../types';
/**
 * Manages user settings persistence and validation
 */
export class ConfigManager {
    /**
     * Get default settings
     */
    static getDefaultSettings() {
        return { ...this.DEFAULT_SETTINGS };
    }
    /**
     * Validate and sanitize user settings
     */
    static validateSettings(settings) {
        const validated = { ...this.DEFAULT_SETTINGS };
        if (settings.mode && Object.values(PhoneticMode).includes(settings.mode)) {
            validated.mode = settings.mode;
        }
        if (settings.digitFormat && Object.values(DigitFormat).includes(settings.digitFormat)) {
            validated.digitFormat = settings.digitFormat;
        }
        if (typeof settings.enableHotkey === 'boolean') {
            validated.enableHotkey = settings.enableHotkey;
        }
        if (Array.isArray(settings.hotkeyModifiers) && settings.hotkeyModifiers.length > 0) {
            validated.hotkeyModifiers = settings.hotkeyModifiers;
        }
        if (typeof settings.hotkeyKey === 'string' && settings.hotkeyKey.length > 0) {
            validated.hotkeyKey = settings.hotkeyKey;
        }
        return validated;
    }
    /**
     * Export settings to JSON string
     */
    static exportSettings(settings) {
        return JSON.stringify(settings, null, 2);
    }
    /**
     * Import settings from JSON string
     */
    static importSettings(json) {
        try {
            const parsed = JSON.parse(json);
            return this.validateSettings(parsed);
        }
        catch (error) {
            throw new Error(`Invalid settings JSON: ${error}`);
        }
    }
    /**
     * Merge partial settings with existing settings
     */
    static mergeSettings(existing, updates) {
        return this.validateSettings({ ...existing, ...updates });
    }
}
ConfigManager.DEFAULT_SETTINGS = {
    mode: PhoneticMode.SMART,
    digitFormat: DigitFormat.BANGLA,
    enableHotkey: true,
    hotkeyModifiers: ['Control', 'Alt'],
    hotkeyKey: 'B',
};
//# sourceMappingURL=config-manager.js.map